import ValuesSection from "./sections/ValuesSection";
import About from "./sections/About";
import AboutUs from "./sections/AboutUs";
import FinancialPlanSection from "./sections/FinancialPlanSection";
import HowWeWork from "./sections/HowWeWork";
import Services from "./sections/Services";
import OurMission from "./sections/OurMission";
import ContactUs from "./sections/ContactUs";
import ContactInfoSection from "./sections/ContactInfoSection";
import "../../css/components/HomePage.css";
import PrimaryButton from "../components/buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <section id="financial-plan">
        <FinancialPlanSection />
      </section>
      <section id="services">
        <Services />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="about-us">
        <AboutUs />
      </section>
      <section id="how-we-work">
        <HowWeWork />
      </section>
      <section id="values">
        <ValuesSection />
      </section>
      <div className="services-section secondary">
        <div className="about-section-content">
          <div className="subtitle uppercase primary">
            Whether you need a single mortgage or a comprehensive financial
            plan, you will receive the same care and dedication. You are always
            welcome here — and always in safe hands.
          </div>
          <div className="content primary">
            Sign up to our monthly newsletter to see the latest news and
            updates.
          </div>
          <PrimaryButton
            text="sign up now"
            onClick={() => navigate("/#contact-us")}
          />
        </div>
      </div>
      <section id="mission">
        <OurMission />
      </section>
      <div className="services-section secondary">
        <div className="about-section-content">
          <div className="row">
            <div className="subtitle uppercase primary">
              Independent Financial Advice, The Gold Standard
            </div>
            <div className="contact-info-divider primary" />
            <div className="subtitle uppercase primary">
              PERSONALISED ADVICE
            </div>
            <div className="contact-info-divider primary" />
            <div className="subtitle uppercase primary">
              ACCESS TO MULTIPLE LENDERS
            </div>
          </div>
        </div>
      </div>
      <section id="contact-us">
        <ContactUs />
      </section>
      <section id="contact-info">
        <ContactInfoSection />
      </section>
    </div>
  );
};

export default HomePage;
